<div class="app-component-container" id="service-details">
    <div class="content">
        <app-s-header [elemIds]="elementSignals['component-header']()"></app-s-header>
    </div>
    <app-base-single-column-text-image
        [elementIds]="elementSignals['service-details']()"></app-base-single-column-text-image>
</div>